<template>
  <div>
    <ca-heading text="Cadastro de Estagiários" />

    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>
      <ca-form
        v-else
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Nome">
              <ca-input
                v-model="intern.internName"
                required
                maxlength="60">
              </ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="CPF">
              <ca-cpf-input
                v-model="intern.cpf"
                required>
              </ca-cpf-input>
            </ca-field>
          </ca-col>
          <ca-col size="12">
            <ca-row>
              <ca-col size="6">
                <ca-field label="Estagiário possui matrícula vinculada ao eSocial?">
                  <e-social-registration-options
                    v-model="intern.registrationOption"
                    :registration-options="misc.registrationOptions"
                    required
                    @change-options="onChangeRegistrationOptions">
                  </e-social-registration-options>
                </ca-field>
              </ca-col>
              <ca-col size="6">
                <ca-field
                  :label="registrationLabel"
                  :icon-tooltip="registrationIconTooltipDesc">
                  <e-social-registration-input
                    v-model="intern.registration"
                    :required="registrationInputEnable"
                    :disabled="!registrationInputEnable">
                  </e-social-registration-input>
                  <small>{{ registrationExtraLabel }}</small>
                </ca-field>
              </ca-col>
            </ca-row>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Sexo">
              <ca-select
                v-model="intern.gender.name">
                <ca-option
                  v-for="option in misc.genders"
                  :key="option.value"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Raça/Cor">
              <ca-select
                v-model="intern.raceColor.name">
                <ca-option
                  v-for="option in misc.raceColor"
                  :key="option.value"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Grau de Instrução">
              <ca-select
                v-model="intern.educationLevel.name">
                <ca-option
                  v-for="option in misc.instructionDegree"
                  :key="option.value"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Data de Nascimento">
              <ca-date-input
                v-model="intern.birthDate"
                required>
              </ca-date-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Categoria">
              <ca-select
                v-model="intern.internCategory.name">
                <ca-option
                  v-for="option in misc.internCategories"
                  :key="option.value"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Data do Início do Estágio">
              <ca-date-input
                v-model="intern.beginDate"
                required>
              </ca-date-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Data do Fim do Estágio">
              <ca-date-input
                v-model="intern.endDate"
                required>
              </ca-date-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Valor da Bolsa">
              <ca-input-currency
                v-model="intern.scholarship"
                maxlength="10"
                required>
              </ca-input-currency>
            </ca-field>
          </ca-col>

          <ca-col size="4">
            <ca-field label="Carga semanal em horas">
              <ca-input
                v-model="intern.weeklyHours"
                mask-pattern="99:99"
                :custom-validations="durationValidation"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="2">
            <ca-field label="Estágio Obrigatório">
              <ca-checkbox
                v-model="intern.required"
                :label="intern.required?'Sim':'Não'" />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Nível do Estágio">
              <ca-select
                v-model="intern.internLevel.name">
                <ca-option
                  v-for="option in misc.internshipLevels"
                  :key="option.value"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Área de Atuação">
              <ca-input
                v-model="intern.occupationArea"
                maxlength="50"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="CEP">
              <ca-cep-data-search
                v-model="intern.zipCode"
                required
                :on-search="onCepSearch"
                :on-search-success="onCepSearchSuccess"
                :on-search-error="onCepSearchError">
              </ca-cep-data-search>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Tipo Logradouro">
              <ca-select
                v-model="intern.streetType"
                required>
                <ca-option
                  v-for="option in misc.publicPlaceType"
                  :key="option.name"
                  :value="option.value">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Logradouro">
              <ca-input
                v-model="intern.street"
                maxlength="80"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Número">
              <ca-input
                v-model="intern.residenceNumber"
                placeholder="Se não houver número, preencha com 'S/N'"
                maxlength="8"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Complemento">
              <ca-input
                v-model="intern.complement"
                maxlength="30">
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Bairro">
              <ca-input
                v-model="intern.neighborhood"
                maxlength="60">
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Cidade">
              <ca-input
                v-model="intern.city"
                maxlength="50"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Código do Município">
              <city-code-input v-model="intern.countryCode"></city-code-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Estado">
              <ca-search-select
                v-model="intern.state.name"
                :selected-option="selectedUf"
                placeholder="Selecione"
                required>
                <ca-option
                  v-for="state in misc.uf"
                  :key="state.name"
                  :value="state.name"
                  placeholder="Selecione">
                  {{ state.value }}
                </ca-option>
              </ca-search-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Telefone">
              <ca-input
                v-model="intern.phone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Email">
              <ca-email-input
                v-model="intern.email"
                maxlength="60">
              </ca-email-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="CNPJ da Instituição de Ensino">
              <cnpj-input v-model="intern.institutionRegistration" required></cnpj-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Nome da Instituição de Ensino">
              <ca-input
                v-model="intern.institutionName"
                maxlength="115"
                required>
              </ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field
              label="Situação no eSocial"
              icon-tooltip="'Novo' para trabalhadores que foram admitidos antes
                da obrigatoriedade do eSocial, 'Admissão' para trabalhadores admitidos
                a partir do início da obrigatoriedade, 'Alterado' para habilitar o envio
                alterações no contrato e 'Sincronizado' se o trabalhador já foi enviado
                por outro sistema.">
              <ca-select
                v-model="intern.esocialStatus.name">
                <ca-option
                  v-for="option in misc.esocialStatus.default"
                  :key="option.name"
                  :value="option.value">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import {
  initFormObject,
  getBoxInformationErrorMessage,
  getWeeklyWorkingHoursValidation,
} from 'packages/common/utils';

import { registrationLabelMixin, registrationActionMixin } from 'packages/components/e-social-registration/eSocialRegistrationMixin';

import { toasterService } from 'packages/common/ds-components';
import { enableRegistrationInput } from 'packages/components/e-social-registration/eSocialRegistrationService';
import { getCepInformation } from 'accountant/employer/establishment/establishmentService';
import {
  getIntern,
  createNewIntern,
  editIntern,
} from './internService';

export default {
  name: 'InternsFormPage',
  mixins: [registrationLabelMixin, registrationActionMixin],
  data() {
    return {
      formKey: 0,
      internId: this.$route.params.id,
      intern: {
        ...initFormObject([
          'internLevel', 'internCategory', 'state',
          { esocialStatus: 'N' },
          { gender: 'M' },
          { raceColor: 'A' },
          { educationLevel: 'G' },
          { internCategory: 'O901' },
          { internLevel: 'F' },
        ]),
        registration: '',
        registrationOption: { value: 'FIRST_REGISTRATION', name: 'FIRST_REGISTRATION' },
        streetType: 'R',
      },
      durationValidation: [getWeeklyWorkingHoursValidation()],
      errorMessage: null,
      selectedUf: null,
    };
  },
  computed: {
    hasInternId() {
      return !!this.internId;
    },
    showLoading() {
      return this.hasInternId && this.intern.loading;
    },
    misc() {
      return this.$store.state.misc;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getEsocialStatus');
      this.$store.dispatch('misc/getRaceColor');
      this.$store.dispatch('misc/getInternCategories');
      this.$store.dispatch('misc/getInstructionDegree');
      this.$store.dispatch('misc/getInternshipLevels');
      this.$store.dispatch('misc/getPublicPlaceType');
      this.$store.dispatch('misc/getUf');
      this.$store.dispatch('misc/getGenders');
      this.$store.dispatch('misc/getRegistrationOptions');

      if (this.hasInternId) {
        this.setIntern();
      }
    },
    async setIntern() {
      this.intern = await getIntern(this.internId);
      this.selectedUf = { value: this.intern.state?.name };
    },
    onCepFetch(response) {
      const {
        neighborhood, city, streetAddress, state, cityCode,
      } = response;

      this.$set(this.intern, 'street', streetAddress);
      this.$set(this.intern, 'neighborhood', neighborhood);
      this.$set(this.intern, 'city', city);
      this.$set(this.intern, 'countryCode', cityCode);
      this.selectedUf = { value: state, label: state };
    },
    onCepSearch() {
      return getCepInformation(this.intern.zipCode);
    },
    onCepSearchSuccess(response) {
      const {
        neighborhood, city, streetAddress, state, cityCode,
      } = response;

      this.$set(this.intern, 'street', streetAddress);
      this.$set(this.intern, 'neighborhood', neighborhood);
      this.$set(this.intern, 'city', city);
      this.$set(this.intern, 'countryCode', cityCode);
      this.selectedUf = { label: state, value: state };
    },
    onCepSearchError() {
      this.$toaster.error('Desculpe, não foi possível localizar o CEP neste momento');
    },
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      return this.hasInternId
        ? editIntern(this.internId, this.intern)
        : createNewIntern(this.intern);
    },
    onSubmitSuccess() {
      this.goBack();
      toasterService.success({
        title: 'Sucesso',
        content: 'As informações foram salvas.',
      });
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
    refreshForm() {
      this.formKey++;
    },
    setRegistrationOption(value) {
      this.intern.registrationOption = value;
      if (!enableRegistrationInput(this.getRegistrationOption())) {
        this.intern.registration = null;
      }
    },
    getRegistrationOption() {
      return this.intern.registrationOption;
    },
  },
};
</script>
